import email from "../../assets/icons/email.png";
import coding from "../../assets/icons/coding.png";
import projects from "../../assets/icons/projects.png";
import { Link } from "react-router-dom";
import "./Footer.scss";

function Footer() {
  return (
    <>
      <div className="footer footer--mobile">
        <nav className="footer__nav" aria-label="Footer navigation">
          <ul className="footer__list">
            <li>
              <a className="footer__link" href="/#projects">
                <div className="footer__items">
                  <img
                    className="footer__icon"
                    src={projects}
                    alt=""
                    aria-hidden="true"
                    width={128}
                    height={128}
                  />
                  <span className="footer__text">projects</span>
                </div>
              </a>
            </li>

            <li>
              <a className="footer__link" href="/#skills">
                <div className="footer__items">
                  <img
                    className="footer__icon"
                    src={coding}
                    alt=""
                    aria-hidden="true"
                    width={128}
                    height={128}
                  />
                  <span className="footer__text">skills</span>
                </div>
              </a>
            </li>

            <li>
              <a className="footer__link" href="/#contact">
                <div className="footer__items">
                  <img
                    className="footer__icon"
                    src={email}
                    alt=""
                    aria-hidden="true"
                    width={128}
                    height={128}
                  />
                  <span className="footer__text">contact</span>
                </div>
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <footer className="footer-desktop">
        <div className="footer-desktop__content">
          <p className="footer-desktop__copyright">© 2026 Chanho Kim</p>

          <nav
            className="footer-desktop__links"
            aria-label="Legal navigation"
          >
            <Link className="footer-desktop__anchor" to="/privacy">
              Privacy Policy
            </Link>
            <Link className="footer-desktop__anchor" to="/cookies">
              Cookie Policy
            </Link>
          </nav>
        </div>
      </footer>
    </>
  );
}

export default Footer;